import { NOTE_ADD_TIDY_DELAY_MS } from './scheduleNoteAddLayoutFollow';

const FLOWCHART_READY_TIMEOUT_MS = 5000;
const FLOWCHART_POLL_MS = 50;

function armParallelLayout(flowchartRef, taskId) {
  const api = flowchartRef?.current;
  if (!api?.followTaskAfterLayout || !api?.autoLayout) return false;

  if (api.isFocusMode?.()) {
    const current = api.getFocusedTaskIds?.();
    const ids = [...(current || []), taskId];
    api.focusTasks?.(ids);
  }

  // Arm before tidy so the layout commit pans to this mission, not an earlier target.
  api.followTaskAfterLayout(taskId);
  setTimeout(() => {
    flowchartRef.current?.autoLayout?.(new Set(), { skipRecordAction: true });
  }, NOTE_ADD_TIDY_DELAY_MS);
  return true;
}

function whenFlowchartReady(flowchartRef, run) {
  const started = Date.now();
  const attempt = () => {
    if (armParallelLayout(flowchartRef, run.taskId)) return;
    if (Date.now() - started >= FLOWCHART_READY_TIMEOUT_MS) return;
    setTimeout(attempt, FLOWCHART_POLL_MS);
  };
  setTimeout(attempt, FLOWCHART_POLL_MS);
}

/**
 * Full tidy, then center the camera on the new parallel mission.
 * If the flow canvas is not mounted, switch to it and arm once it is.
 */
export function scheduleParallelMissionLayout(flowchartRef, taskId, { ensureFlowView } = {}) {
  if (!taskId) return;
  if (armParallelLayout(flowchartRef, taskId)) return;
  ensureFlowView?.();
  whenFlowchartReady(flowchartRef, { taskId });
}
